import { Amplify } from "aws-amplify";
import { amplifyConfig as cognitoConfig } from "./cognito";

// Amplify carries only Cognito here: the app's data goes through the backend
// gateway (Apollo), and the AppSync API the V4 stack used is retired.
export const amplifyConfig = cognitoConfig;

// Configure Amplify once with the merged configuration
// This should be called before any Amplify operations
let isConfigured = false;

export const configureAmplify = () => {
  if (isConfigured) {
    console.warn("Amplify is already configured. Skipping reconfiguration.");
    return;
  }

  Amplify.configure(amplifyConfig);
  isConfigured = true;
  console.log("Amplify configured successfully");
};

// Auto-configure on module load to ensure it happens early
if (typeof window !== "undefined") {
  configureAmplify();
}
